import axios from "axios";

import { getToken, clearToken } from "./utils/tokenStorage";
// Empty baseURL = use same origin
// Nginx proxies /api/ to backend port 8000
const api = axios.create({
  baseURL: "",
  timeout: 60000,
});

api.interceptors.request.use((config) => {
  const token = getToken("aegis_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      clearToken("aegis_token");
      if (window.location.pathname !== "/login" && window.location.pathname !== "/register") {
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);

export default api;
